import { IconSvgElement } from "@hugeicons/react";
import { FC } from "react";
import { useLocation } from "react-router-dom";
import { BadgeVariant } from "shared/components";
import { NavLink } from "./NavLink";
import { BetaBadge } from "./BetaBadge";

export const BetaNavLink: FC<{
  to: string;
  label: string;
  HugeIcon: IconSvgElement;
}> = ({ to, label, HugeIcon }) => {
  const { pathname } = useLocation();

  return (
    <NavLink to={to} HugeIcon={HugeIcon}>
      <div className="flex gap-2 items-center">
        <p>{label}</p>
        <BetaBadge
          className="mix-blend-multiply"
          variant={pathname === to ? BadgeVariant.PRIMARY : BadgeVariant.BASE}
        />
      </div>
    </NavLink>
  );
};
